import { isIncludeProductSelection, ProductSelection } from '../product-selection/ProductSelectionTypes';
import { LineItemKey } from '../../store/api';

export const convertLineItemKeysToDto = (productSelection: ProductSelection): LineItemKey[] => {
    const lineItemKeysDto = isIncludeProductSelection(productSelection) ? productSelection.included : [];

    return lineItemKeysDto.map(lineItemKey => ({
        productId: lineItemKey.productId,
        usageCondition:
            typeof lineItemKey.usageCondition?.usageLimit === 'number' &&
            typeof lineItemKey.usageCondition?.termLimit === 'number' &&
            lineItemKey.usageCondition?.lendingModel
                ? {
                      usageLimit: lineItemKey.usageCondition.usageLimit,
                      termLimit: lineItemKey.usageCondition.termLimit,
                      lendingModel: lineItemKey.usageCondition.lendingModel
                  }
                : undefined,
        subscriptionPeriodType: lineItemKey.subscriptionPeriodType
    }));
};
